import React, {useEffect, useState} from 'react';
import Container from 'react-bootstrap/Container';
import config_release from '../config/config_release.json';
import { getVersion } from '../apis/aboutApi';
import { Row, Col, Table, Alert } from 'react-bootstrap';
export const AboutPage = () => 
{
    const [versions, setVersions] = useState(null);
    const [ errorMessage, setErrorMessage] = useState(null);
    // get all from config.json and combine together 
    // if the config.json is not found, use the default values
    const major = config_release.EnvironmentVariables[0].Value;
    const minor = config_release.EnvironmentVariables[1].Value;
    const build = config_release.EnvironmentVariables[2].Value;
    const release = config_release.EnvironmentVariables[3].Value;

    //use getAbout and load results int he page
    useEffect(() => {
        async function fetchVersion(){
            try
            {
                const response = await getVersion();
                setVersions(response);
            }
            catch (error){
                if (error.status === 403)
                {
                    setErrorMessage('You do not have permission to view version information. Please contact your administrator.');
                }
                else
                {
                    setErrorMessage(error.message);
                }
            }
            
        }
        fetchVersion(); 
    }, []);

    return (
        <>
        {
            errorMessage && (
                <Alert variant="danger" onClose={() => setErrorMessage(false)} dismissible>
                    {errorMessage}
                </Alert>
            )
        }
        {
            !errorMessage && (
                <>
                <h3 className="display-6">About</h3>
                <Container fluid className="p-5 rounded-3">
                <Row>
                    <Col lg={4} md={10} sm={12}>
                    <Table size="sm" bordered>
                    <thead>
                        <tr>
                            <th>Component</th>
                            <th>Version</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>UI Version</td>
                            <td>{major}.{minor}.{build}.{release}</td>
                        </tr>
                        {versions?.apiVersion && (
                            <tr>
                                <td>{versions.apiVersion.label}</td>
                                <td>{versions.apiVersion.version}</td>
                            </tr>
                        )}
                        {versions?.componentVersions?.flatMap((componentVersion, cvIndex) => 
                            componentVersion.components?.map((component, compIndex) => (
                                <tr key={`${cvIndex}-${compIndex}`}>
                                    <td>{component.label}</td>
                                    <td>{component.version}</td>
                                </tr>
                            )) || []
                        )}
                        {
                            versions?.authVersion && (
                                <tr>
                                    <td>{versions.authVersion.label}</td>
                                    <td>{versions.authVersion.version}</td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
                    </Col>
                </Row>
               
            </Container>
            </>
            )
        }
            
        </>
    );
}